var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3c6394a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-variable__values__value__variant-toolbar" };
const _hoisted_2 = {
    key: 0,
    class: "component-variable-variant-popover"
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "ds" }, "Default variant value.", -1 /* HOISTED */));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createTextVNode(" This is the "),
    /*#__PURE__*/ _createElementVNode("strong", null, "default"),
    /*#__PURE__*/ _createTextVNode(" variant for this campaign. ")
], -1 /* HOISTED */));
const _hoisted_5 = {
    key: 1,
    class: "component-variable-variant-popover"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "ds" }, "Remove variant value.", -1 /* HOISTED */));
const _hoisted_7 = { class: "action-section" };
const _hoisted_8 = {
    key: 2,
    class: "component-variable-variant-popover"
};
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "ds" }, "Add variant value.", -1 /* HOISTED */));
const _hoisted_10 = { class: "action-section" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "inline-divider" }, "|", -1 /* HOISTED */));
const _hoisted_12 = { class: "component-variable__values__value__variant-toolbar__message" };
const _hoisted_13 = { key: 0 };
const _hoisted_14 = { key: 1 };
const _hoisted_15 = { key: 2 };
const _hoisted_16 = { class: "component-variable__values__value__variant-toolbar__controls" };
import { onClickOutside } from "@vueuse/core";
import { ElPopover } from "element-plus";
import { translateMessage } from "src/shared/store/ai-conversation/translateMessage";
import LoadingAnimation from "src/shared/v-components/loading-animation/LoadingAnimation.vue";
import { computed, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableVariantLabel',
    props: {
        value: {},
        variableDisplayName: {},
        variant: {},
        hasVariant: { type: Boolean },
        defaultVariant: {},
        canBeTranslated: { type: Boolean }
    },
    emits: ["removeVariant", "addVariant", "addTranslatedVariant"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const isVisible = ref(false);
        const target = ref();
        const isDefaultVariant = computed(() => {
            return (props.variant === props.defaultVariant || props.variant === "default");
        });
        const isFallingBackToDefault = computed(() => {
            return !props.hasVariant && !isDefaultVariant.value;
        });
        const showVariantMessage = computed(() => {
            return !isDefaultVariant.value;
        });
        const normalizedVariant = computed(() => {
            return isDefaultVariant.value ? props.defaultVariant : props.variant;
        });
        onClickOutside(target, () => {
            isVisible.value = false;
        });
        const emit = __emit;
        const removeVariant = () => {
            emit("removeVariant");
            isVisible.value = false;
        };
        const isTranslating = ref(false);
        const showLoadingAnimation = ref(false);
        const showSuccessAnimation = ref(false);
        // write a test function called wait2 seconds that does a set Timeout for 2 seconds
        const wait2Seconds = () => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve();
                }, 2000);
            });
        });
        const isString = (value) => {
            return typeof value === "string";
        };
        const translate = () => __awaiter(this, void 0, void 0, function* () {
            if (!isString(props.value)) {
                return;
            }
            if (!props.canBeTranslated || !isFallingBackToDefault.value) {
                return;
            }
            try {
                isTranslating.value = true;
                showSuccessAnimation.value = false;
                showLoadingAnimation.value = true;
                const { translatedMessage } = yield translateMessage({
                    message: props.value,
                    language: props.defaultVariant,
                    targetLanguage: props.variant,
                });
                console.log("Translated message:", translatedMessage);
                emit("addTranslatedVariant", translatedMessage);
                showSuccessAnimation.value = true;
                showLoadingAnimation.value = false;
                yield wait2Seconds();
                showSuccessAnimation.value = false;
            }
            catch (error) {
                console.error("Error translating message:", error);
            }
            finally {
                isTranslating.value = false;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(ElPopover), {
                    placement: 'bottom-start',
                    width: '300px',
                    trigger: 'click',
                    visible: isVisible.value,
                    "onUpdate:visible": _cache[4] || (_cache[4] = ($event) => ((isVisible).value = $event)),
                    persistent: false,
                    "show-arrow": false
                }, {
                    reference: _withCtx(() => [
                        _createElementVNode("span", {
                            onClick: _cache[0] || (_cache[0] = ($event) => (isVisible.value = true)),
                            class: _normalizeClass(["component-variable__values__value__variant-toolbar__label", {
                                    'component-variable__values__value__variant-toolbar__label--active': isVisible.value,
                                    'component-variable__values__value__variant-toolbar__label--warning': isFallingBackToDefault.value,
                                }])
                        }, _toDisplayString(normalizedVariant.value), 3 /* TEXT, CLASS */)
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            ref_key: "target",
                            ref: target
                        }, [
                            (isDefaultVariant.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _hoisted_3,
                                    _createElementVNode("p", null, [
                                        _createTextVNode(" You are currently editing the "),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.defaultVariant), 1 /* TEXT */),
                                        _createTextVNode(" variant. ")
                                    ]),
                                    _hoisted_4
                                ]))
                                : (_ctx.hasVariant && _ctx.variant !== _ctx.defaultVariant)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _hoisted_6,
                                        _createElementVNode("p", null, [
                                            _createTextVNode(" You are currently editing the "),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.variant), 1 /* TEXT */),
                                            _createTextVNode(" variant. ")
                                        ]),
                                        _createElementVNode("p", null, [
                                            _createTextVNode(" Would you like to permanently delete this value and instead use the "),
                                            _createElementVNode("strong", null, "default (" + _toDisplayString(_ctx.defaultVariant) + ")", 1 /* TEXT */),
                                            _createTextVNode(" value? ")
                                        ]),
                                        _createElementVNode("p", _hoisted_7, [
                                            _createElementVNode("a", {
                                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (removeVariant()), ["prevent"]))
                                            }, "Remove and use Default")
                                        ])
                                    ]))
                                    : (!_ctx.hasVariant && _ctx.variant !== _ctx.defaultVariant)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _hoisted_9,
                                            _createElementVNode("p", null, [
                                                _createElementVNode("strong", null, _toDisplayString(props.variableDisplayName), 1 /* TEXT */),
                                                _createTextVNode(" does not have a value for "),
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.variant), 1 /* TEXT */),
                                                _createTextVNode(". It is currently using the "),
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.defaultVariant), 1 /* TEXT */),
                                                _createTextVNode(" variant. ")
                                            ]),
                                            _createElementVNode("p", null, [
                                                _createTextVNode(" Would you like to add a variant for "),
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.variant), 1 /* TEXT */),
                                                _createTextVNode("? ")
                                            ]),
                                            _createElementVNode("p", _hoisted_10, [
                                                _createElementVNode("a", {
                                                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (emit('addVariant')), ["prevent"]))
                                                }, "Add \"" + _toDisplayString(_ctx.variant) + "\" value\"", 1 /* TEXT */),
                                                _hoisted_11,
                                                _createElementVNode("a", {
                                                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (isVisible.value = false), ["prevent"]))
                                                }, "Dismiss")
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                        ], 512 /* NEED_PATCH */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["visible"]),
                _createElementVNode("div", _hoisted_12, [
                    (isDefaultVariant.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                        : (_ctx.hasVariant)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                _createTextVNode("This is an "),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.variant), 1 /* TEXT */),
                                _createTextVNode(" version value.")
                            ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                _createTextVNode("This is an "),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.defaultVariant), 1 /* TEXT */),
                                _createTextVNode(" version value.")
                            ]))
                ]),
                _createElementVNode("div", _hoisted_16, [
                    (_ctx.canBeTranslated && isFallingBackToDefault.value && !isTranslating.value)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "far fa-language",
                            onClick: translate
                        }))
                        : _createCommentVNode("v-if", true),
                    _withDirectives(_createVNode(LoadingAnimation, {
                        "show-loading-animation": showLoadingAnimation.value,
                        "show-success-animation": showSuccessAnimation.value
                    }, null, 8 /* PROPS */, ["show-loading-animation", "show-success-animation"]), [
                        [_vShow, isTranslating.value]
                    ])
                ])
            ]));
        };
    }
});
